import { z } from "zod";
import { UIElementType } from "../../../../AppConstants";
import { AppUtility } from "../../../../utils/utility";
import { t } from "i18next";

const getReplacementDeviceSchema = (existingRanges) => {
    return z.object({
        StartFrequencyReposition: z
            .number()
            .positive()
            .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("replacementDevice.startFrequency"), isRequired: true })),
        EndFrequencyReposition: z
            .number()
            .positive()
            .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("replacementDevice.endFrequency"), isRequired: true })),
        RepositionPercentage: z
            .number()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            })
            .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("replacementDevice.repositionPercentage"), isRequired: true }))
    }).superRefine((data, ctx) => {
        const startRange = data.StartFrequencyReposition;
        const endRange = data.EndFrequencyReposition;

        // Check if both ranges are provided
        if (startRange !== null && endRange !== null) {
            // Check if end range is greater than start range
            if (endRange <= startRange) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "End frequency must be greater than start frequency",
                    path: ["EndFrequencyReposition"],
                });
            }

            // Check if the range overlaps with existing ranges
            if (AppUtility.isNotValidRange(startRange, endRange, existingRanges)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "The entered range overlaps with an existing range",
                    path: ["StartFrequencyReposition"],
                });
            }
        }
    });
};

const getReplacementDeviceDefaultValue = (value = null) => {
    return {
        StartFrequencyReposition: value ? value?.StartFrequencyReposition : null,
        EndFrequencyReposition: value ? value?.EndFrequencyReposition : null,
        RepositionPercentage: value ? value?.RepositionPercentage : null,
        ReplaceDeviceId: value ? value?.ReplaceDeviceId : null,
    };
};

export { getReplacementDeviceSchema, getReplacementDeviceDefaultValue };